import { render, staticRenderFns } from "./NewTasksKiko.vue?vue&type=template&id=38797b92&scoped=true"
import script from "./NewTasksKiko.vue?vue&type=script&lang=js"
export * from "./NewTasksKiko.vue?vue&type=script&lang=js"
import style0 from "./NewTasksKiko.vue?vue&type=style&index=0&id=38797b92&lang=less&scoped=true"
import style1 from "./NewTasksKiko.vue?vue&type=style&index=1&id=38797b92&lang=less&scoped=true"
import style2 from "./NewTasksKiko.vue?vue&type=style&index=2&id=38797b92&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38797b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38797b92')) {
      api.createRecord('38797b92', component.options)
    } else {
      api.reload('38797b92', component.options)
    }
    module.hot.accept("./NewTasksKiko.vue?vue&type=template&id=38797b92&scoped=true", function () {
      api.rerender('38797b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/HostessTasks/components/NewTasksKiko.vue"
export default component.exports